// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@vanmeter/Overrides/Components/OrderUploadErrorsModal";
import { modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

orderUploadErrorsModalStyles.tableWrapper = {
    css: css`
        display: block;
        width: 100%;
        overflow: auto;
    `,
};

orderUploadErrorsModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

orderUploadErrorsModalStyles.continueUploadButton = {
    ...modalButtonsActionStyles.submitButton,
};

orderUploadErrorsModalStyles.cancelUploadButton = {
    ...modalButtonsActionStyles.cancelButton,
};

orderUploadErrorsModalStyles.modal = orderUploadErrorsModalStyles.errorMessagesModal = {
    sizeVariant: "medium",
};

orderUploadErrorsModalStyles.dataTable = {};
